import axios from "axios";
import FindLocation from "../models/FindLocation";
import { DefaultModel } from "../models/IModel";
import Location from "../models/Location";
import http from "./http";
import environments from "../environment";

export interface EmailContent {
	content: string;
}

export interface EmailTemplateData {
	name?: string;
	description?: string;
	id?: number;
	subject?: string;
}

export interface EmailKeyword {
	name: string;
	description: string;
	descriptionManual?: string;
	group?: string;
	sortOrder?: number;
	enabled?: boolean;
}

export async function getEmailKeywork(): Promise<{
	data: EmailKeyword[];
}> {
	let results = await http.get(`/utility/recommend-email-content-keyword`);
	return {
		data: results.data?.data || [],
	};
}

export async function saveEmailKeywork(keywords: EmailKeyword[]): Promise<{
	data: EmailKeyword[];
}> {
	const results = await http.post(`/utility/recommend-email-content-keyword`, {
		data: keywords,
	});

	return {
		data: results.data?.data || [],
	};
}

export async function getEmailContent(id: number): Promise<{
	data: string;
}> {
	let results = await http.get(`/utility/email-content/${id}`);
	return {
		data: results.data?.content || "",
	};
}
export async function getButton(): Promise<{
	data: EmailTemplateData[];
}> {
	let results = await http.get(`/utility/email-content`);
	return {
		data: results.data || [],
	};
}

export const updateContentEmail = async (id: number, content: string, name?: string, subject?: string) => {
	let { data } = await http.post(`/utility/email-content`, {
		targetType: id,
		...(name !== undefined ? { name } : {}),
		...(subject !== undefined ? { subject } : {}),
		data: {
			content: content,
		},
	});

	return data;
};

export const previewContentEmail = async (
	id: number,
	content: string
): Promise<{
	html: string;
	sampleData?: Record<string, string>;
}> => {
	let { data } = await http.post(`/utility/email-content/preview`, {
		targetType: id,
		content,
	});

	return {
		html: data?.html || "",
		sampleData: data?.sampleData || {},
	};
};

export type OrderEmailSubjectCatalog = {
	bookingConfirmed: string;
	orderCanceled: string;
	single: string;
	double: string;
	triple: string;
	manyFields: string;
	labels: {
		date: string;
		time: string;
		address: string;
		quantity: string;
		price: string;
	};
};

export async function getOrderEmailSubjectTemplates(): Promise<OrderEmailSubjectCatalog> {
	const results = await http.get(`/utility/order-email-subject-templates`);
	return results.data as OrderEmailSubjectCatalog;
}

export async function saveOrderEmailSubjectTemplates(
	catalog: OrderEmailSubjectCatalog
): Promise<{ message?: string; data: OrderEmailSubjectCatalog }> {
	const { data } = await http.post(`/utility/order-email-subject-templates`, { data: catalog });
	return data as { message?: string; data: OrderEmailSubjectCatalog };
}

// ---------------------------------------------------------------------------
// Version history API (Phase 3 Slice 3A)
// ---------------------------------------------------------------------------

export interface EmailVersion {
	id: number;
	status: "draft" | "published";
	name?: string;
	subject?: string;
	content: string;
	/** Sequelize serializes attributes in camelCase — NOT the snake_case column names. */
	createdAt: string;
	publishAt?: string;
	createdBy?: string | number;
}

export async function listEmailVersions(id: number): Promise<EmailVersion[]> {
	const { data } = await http.get(`/utility/email-content/${id}/versions`);
	return data || [];
}

export async function saveEmailDraft(
	id: number,
	payload: { content: string; name?: string; subject?: string }
): Promise<{ message?: string }> {
	const { data } = await http.post(`/utility/email-content/${id}/draft`, payload);
	return data;
}

export async function publishEmail(
	id: number,
	payload: { content: string; name?: string; subject?: string; publishAt?: string }
): Promise<{ message?: string }> {
	const { data } = await http.post(`/utility/email-content/${id}/publish`, payload);
	return data;
}

export async function restoreEmailVersion(id: number, versionId: number): Promise<{ message?: string }> {
	const { data } = await http.post(`/utility/email-content/${id}/restore`, { versionId });
	return data;
}
